var _defs, _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _path3, _path4, _path5, _line7, _path6, _line8, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDamagedTitlescopy2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448.55 448.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:10.71px;}.cls-1,.cls-2{fill:none;stroke:#f26725;stroke-linecap:round;stroke-linejoin:round;}.cls-2{stroke-width:8.17px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m205.29,46.93h83.68c2.04,0,3.7,2.85,3.7,6.36v172.02c0,3.51-1.66,6.36-3.7,6.36h-21.28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m169.04,231.67h-42.09c-2.04,0-3.7-2.85-3.7-6.36V53.29c0-3.51,1.66-6.36,3.7-6.36h51.39"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 203.08,
    y1: 80.98,
    x2: 291.83,
    y2: 80.98
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 123.26,
    y1: 80.98,
    x2: 179.68,
    y2: 80.98
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 200.96,
    y1: 122.08,
    x2: 291.83,
    y2: 122.08
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 177.01,
    y1: 122.08,
    x2: 179.68,
    y2: 122.08
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 143.36,
    y1: 122.08,
    x2: 145.14,
    y2: 122.08
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 123.26,
    y1: 122.08,
    x2: 143.36,
    y2: 122.08
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m260.8,282.75l-93.97-157.72c-2.24-3.75-7.68-3.73-9.88.04l-1.34,2.29c-6.03,10.33-6.97,22.85-2.56,33.96l41.05,103.33c3.67,9.24,12.43,15.44,22.36,15.83,8.62.34,16.46,5.08,20.77,12.55l1.44,2.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m257.93,284.41l-15.44,8.91c-6.31,3.64-8.48,11.72-4.83,18.03l34.36,59.52c11.63,20.15,37.39,27.05,57.54,15.42,20.15-11.63,27.05-37.39,15.42-57.54-6.13-10.62-17.58-17.04-29.84-16.72-17.27.45-33.41-8.59-42.05-23.55h0c-3.06-5.31-9.85-7.13-15.16-4.06Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m210.01,293.36c-1.09,1.39-2.04,2.9-2.84,4.52l-1.27,2.6"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 194.7,
    y1: 266.01,
    x2: 182.96,
    y2: 289.27
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m185.94,290.73l16.02,7.81c6.55,3.2,9.27,11.1,6.08,17.65l-30.13,61.77c-10.2,20.91-35.42,29.59-56.32,19.39h0c-20.91-10.2-29.59-35.42-19.39-56.32,5.38-11.02,16.35-18.22,28.61-18.76,17.26-.76,32.73-10.9,40.3-26.43,2.69-5.51,9.33-7.8,14.84-5.11Z"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 243.34,
    y1: 252.19,
    x2: 252.4,
    y2: 231.67
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 138.63,
    cy: 360.86,
    r: 17.21
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 310.47,
    cy: 350.64,
    r: 17.21
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDamagedTitlescopy2);
export default __webpack_public_path__ + "static/media/Damaged Titles copy 2.d4b5c277a8222a5bf8fccb7594f673df.svg";
export { ForwardRef as ReactComponent };